// extracted by mini-css-extract-plugin
module.exports = {"container":"login_forgot-module--container--p-Zsk","button":"login_forgot-module--button--bDdK9"};